module.exports = __webpack_public_path__ + "static/media/tech-holistic-3.16913042.png";